module.exports = __webpack_public_path__ + "img/lw.1dc2a0f4.png";